import { render, staticRenderFns } from "./new-lost-patient-v2.vue?vue&type=template&id=a4d22f02&scoped=true&lang=pug&"
import script from "./new-lost-patient-v2.vue?vue&type=script&lang=ts&"
export * from "./new-lost-patient-v2.vue?vue&type=script&lang=ts&"
import style0 from "./new-lost-patient-v2.vue?vue&type=style&index=0&id=a4d22f02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d22f02",
  null
  
)

export default component.exports